<template>
    <div v-if="searchClient">
        <ais-instant-search
            v-bind:search-client="searchClient"
            index-name="product_masters"
            :on-state-change="onStateChange"
            :middlewares="middlewares"
            :initial-ui-state="initialUiState"
        >
            <ais-configure :hits-per-page.camel="20" :filters="filters" />
            <div class="row">
                <div class="col-md-8">
                    <div class="search-banner">
                        <div class="container-md container-fluid">
                            <div class="searchbox">
                                <ais-search-box placeholder="Search products, brands & categories" autofocus />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container">
                <ais-stats class="mt-6 mt-md-0 text-primary">
                    <template v-slot="{ hitsPerPage, nbPages, nbHits, page, processingTimeMS, query }">
                        <div class="text-center my-5" v-if="nbHits == 0 && query">
                            <img src="/images/empty-search.png" class="empty-cart-image" alt="No Search Results">
                            <h5 class="mt-3">No results found for <q>{{ query }}</q></h5>
                        </div>
                        <span v-else></span>
                    </template>
                </ais-stats>
                <div class="search-panel mt-3" v-if="enabled">
                    <div class="search-panel__filters">
                        <ais-panel>
                            <template v-slot:header="{ hasRefinements }">
                                <span class="text-primary" v-if="hasRefinements">brand</span>
                            </template>
                            <ais-refinement-list attribute="brand" />
                        </ais-panel>
                        <ais-panel>
                            <template v-slot:header="{ hasRefinements }">
                                <span class="text-primary" v-if="hasRefinements">category</span>
                            </template>
                            <ais-refinement-list attribute="category" />
                        </ais-panel>
                    </div>

                    <div class="search-panel__results">
                        <div class="content-area">
                            <ais-stats class="mt-0 mb-3 text-primary">
                                <template v-slot="{ hitsPerPage, nbPages, nbHits, page, processingTimeMS, query }">
                                    <span v-if="nbHits > 0 && query">Showing {{ nbHits }} results for <q>{{ query }}</q></span>
                                    <span v-if="nbHits > 0 && !query"></span>
                                </template>
                            </ais-stats>
                            <ais-hits :transform-items="transformItems">
                                <template slot="item" slot-scope="{ item }">
                                    <div class="card border-0 mx-1 bg-transparent pro-card">
                                        <a :href="'/product/'+item.slug">
                                            <img class="card-img-top" :src="'/'+item.image" :alt="item.title" /> 
                                        </a>
                                        <div class="card-body px-0">
                                            <a :href="'/product/'+item.slug" class="product-title">
                                                <ais-highlight :hit="item" attribute="title" />
                                            </a>
                                        </div>
                                        <div class="product-meta">
                                            <div v-if="products[item.slug] == undefined">Loading...</div>
                                            <div v-else>
                                                <div class="d-flex flex-row align-items-center justify-content-between pt-1">
                                                    <div class="mrp-product fw-bold">MRP : ₹{{ products[item.slug][0].mrp | number_format }}</div>
                                                    <div class="offer-mrp-product fw-bold" v-if="products[item.slug][0].offer_price == 0">₹{{ products[item.slug][0].our_price | number_format }}</div>
                                                    <div class="offer-mrp-product fw-bold" v-else>
                                                        <span>₹{{ products[item.slug][0].offer_price | number_format }} <i class="fa-solid fa-fire-flame-curved"></i></span>
                                                    </div> 
                                                </div>
                                                <div class="text-center py-3 product-action-block">
                                                    <div v-if="products[item.slug][0].is_master_product">
                                                        <a :href="'/product/'+item.slug" 
                                                            class="btn bg-white text-primary border-primary w-100 py-1">
                                                            View Options
                                                        </a>
                                                    </div>
                                                    <div v-else>
                                                        <div v-if="products[item.slug][0].in_stock">
                                                            <div class="d-flex flex-row align-items-center justify-content-between pt-1 btn bg-primary text-white border-primary w-100 py-1 fw-bold" v-if="products[item.slug][0].session_quantity"> 
                                                                <button class="btn-qty" @click="updateCart(products[item.slug][0].child_id, item.slug, 'minus')"><i class="fa-solid fa-minus"></i></button>
                                                                <div class="product-qty">{{ products[item.slug][0].session_quantity }}</div>
                                                                <button class="btn-qty" @click="updateCart(products[item.slug][0].child_id, item.slug, 'plus')"><i class="fa-solid fa-plus"></i></button>
                                                            </div>
                                                            <button class="btn bg-white text-primary border-primary w-100 py-1 add-cart-btn" @click="updateCart(products[item.slug][0].child_id, item.slug, 'add')" v-else>Add</button>
                                                        </div>
                                                        <div v-else>
                                                            <button class="btn out-of-stock w-100 py-1">
                                                                Out of Stock
                                                                <span class="out-of-stock-icon cursor-pointer" @click="notifyStockIn(products[item.slug][0].child_id, item.slug)" v-if="isLoggedIn && products[item.slug][0].stock_notifiable == 1">
                                                                    <img src="/website-frontend/tws/assets/img/bell.png" width="25" alt="bell-icon">
                                                                </span>
                                                            </button>
                                                            <span class="will-notify" v-if="isLoggedIn && products[item.slug][0].stock_notifiable == 0">Will notify when available</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </ais-hits>
                        </div>

                        <div class="search-pagination-responsive">
                            <ais-pagination :show-first="false" :show-last="false" :total-pages="4">
                                <template v-slot="{ nbPages }">
                                    <span v-if="nbPages == 0"></span>
                                </template>
                            </ais-pagination>
                        </div>
                        <div class="search-pagination">
                            <ais-pagination>
                                <template v-slot="{ nbPages }">
                                    <span v-if="nbPages == 0"></span>
                                </template>
                            </ais-pagination>
                        </div>
                    </div>
                </div>
                <div class="search-placeholder mt-5" v-else>
                    <div class="text-center mb-5">
                        <img src="/images/search-placeholder.png" class="empty-cart-image" alt="Search Placeholder">
                        <h5 class="mt-3">Start typing your search query to get results.</h5>
                    </div>
                </div>
            </div>
        </ais-instant-search>
    </div>
</template>
<script>
    import algoliasearch from 'algoliasearch/lite';

    function middleware({ instantSearchInstance }) {
        return {
            onStateChange({ uiState }) {
                setTimeout(() => {
                    let hits = instantSearchInstance.helper.lastResults.hits;
                    if (hits.length > 0) {
                        const event = new CustomEvent("search-completed", {
                            detail: {
                                hits: hits
                            } 
                        });
                        document.dispatchEvent(event);
                    }
                }, "500");
            },
        }
    }
    export default {
        name: "SearchAlgolia",
        data() {
            return {
                appUrl: document.head.querySelector('meta[name="app-url"]').content,
                filters: '',
                searchClient: null,
                products: {},
                enabled: false,
                debounceTimer: null,
                initialUiState: {
                    product_masters: {
                        query: ''
                    }
                },
                middlewares: [middleware]
            };
        },
        filters: {
            number_format: function (value){
                return parseFloat(value).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })
            }
        },
        props: {
            isLoggedIn: {
                type: Boolean,
                required: true
            },
            query: {
                type: String,
                required: true
            }
        },
        mounted() {
            let self = this;
            this.fetchCustomerBrands();
            document.addEventListener('search-completed', (e)=>{
                self.debouncedSyncProducts(e.detail.hits);
            });
        },
        methods: {
            debouncedSyncProducts(hits) {
                let self = this;
                // Clear the previous timer
                if (self.debounceTimer) {
                    clearTimeout(self.debounceTimer);
                }
                // Set a new timer with 300ms delay
                self.debounceTimer = setTimeout(() => {
                    self.syncProducts(hits);
                }, 300);
            },
            fetchCustomerBrands() {
                let self = this;
                axios.get(`${self.appUrl}/algolia-search-filter`).then(function(response) {
                    self.filters = response.data.filters;
                    self.searchClient = algoliasearch(
                        response.data.app_id,
                        response.data.search_key
                    );
                    if (self.query != "") {
                        self.enabled = true;
                        self.initialUiState.product_masters.query = self.query;
                    }
                }).catch(function (response) {
                    console.log(response);
                    alert('Something went wrong, please try again.');
                });
            },
            onStateChange({ uiState, setUiState }) {
                let self = this;
                if (uiState.product_masters.query == "" || uiState.product_masters.query == undefined) {
                    self.enabled = false;
                } else {
                    self.enabled = true;
                }
                setUiState(uiState);
            },
            syncProducts(hits) {
                let self = this;
                let pids = [];
                if (hits.length > 0) {
                    hits.forEach((hit) => {
                        pids.push(hit.slug);
                    });

                    axios.post(`${self.appUrl}/fetch-products-meta`, {
                        pids: pids
                    }).then(function(response) {
                        self.products = {...self.products, ...response.data.products};
                    }).catch(function (response) {
                        console.log(response);
                        alert('Something went wrong, please try again.');
                    });
                }
            },
            transformItems(hits) {
                if (hits.length > 0) {
                    const event = new CustomEvent("search-completed", {
                        detail: {
                            hits: hits
                        } 
                    });
                    document.dispatchEvent(event);
                }

                return hits;
            },
            updateCart(product_id, slug, action) {
                let self = this;
                axios.post(`${self.appUrl}/add-cart-values`, {
                    product_id: product_id,
                    action: action,
                    page: 'card'
                }).then(function(response) {
                    self.products[slug][0].session_quantity = response.data.quantity;
                    self.renderCartCount(response.data.cart_count);
                }).catch(function (response) {
                    console.log(response);
                    alert('Something went wrong, please try again.');
                });
            },
            notifyStockIn(product_id, slug) {
                let self = this;
                axios.post(`${self.appUrl}/notify-stock-in`, {
                    product_id: product_id,
                }).then(function(response) {
                    if (response.data.success) {
                        self.products[slug][0].stock_notifiable = false;
                    }
                }).catch(function (response) {
                    console.log(response);
                    alert('Something went wrong, please try again.');
                });
            },
            renderCartCount(cart_count) {
                if (cart_count > 0) {
                    document.querySelector(".cartCountValue").classList.remove("d-none");
                    document.querySelector(".cartCountValue").textContent = cart_count;
                } else {
                    document.querySelector(".cartCountValue").classList.add("d-none");
                }
            }
        }
    }
</script>
<style>
.search-panel {
    display: flex;
}

.search-panel__filters {
    flex: 1;
}

.search-panel__results {
    flex: 3;
}
.search-panel .ais-Hits-list {
    display: grid;
    grid-template-columns: 25% 25% 25% 25%;
    grid-gap: 10px;
}
.search-pagination {
    margin: 2rem auto;
    text-align: center;
}
.search-pagination-responsive {
    margin: 2rem auto;
    text-align: center;
    display: none;
}
.search-banner {
    background: none;
    padding: 10px 0;
    position: fixed;
    top: 7px;
    width: 100%;
    max-width: 960px;
    z-index: 1021;
    left:0;
    right:0;
    margin-left: auto;
    margin-right: auto;
}
.searchbox .ais-SearchBox-form::before {
    font-family: "FontAwesome";
    background: unset;
    font-weight: 900;
    content: "\f002";
    left: 1rem;
    position: absolute;
    top: 47%;
    font-size: 18px;
    color: var(--secondary-color);
}
.searchbox .ais-SearchBox {
    width: 100%;
}
.searchbox {
    display: flex;
    justify-content: center;
}
.search-banner.sticky {
    position: fixed;
    z-index: 1021;
    width: 100%;
}

@media (max-width: 1539.98px) {
    .search-banner {
        max-width: 700px;
    }
}

@media (max-width: 1199.98px) {
    .search-banner {
        max-width: 600px;
    }
}

@media (max-width: 991.98px) {
    .search-banner {
        max-width: 500px;
    }
    .search-panel .ais-Hits-list {
        grid-template-columns: 33.33% 33.33% 33.33%;
    }
}

@media (max-width: 767.98px) {
    .search-banner {
        top: 58px;
        max-width: 100%;
    }
    .header_area.sticky .header-main.search-active {
        height: 0 !important;
    }
    .classy-nav-container.search-active {
        display: flex !important;
    }
    .search-banner.sticky {
        top: 0;
        padding: 12px 0;
        margin-left: unset;
        margin-right: unset;
        max-width: 100%;
        background: #fff;
    }

    .search-panel .ais-Hits-list {
        grid-template-columns: 50% 50%;
    }

    .search-panel .search-panel__filters {
        display: none;
    }

    .searchbox .ais-SearchBox-input {
        padding: 0.6rem 2.5rem;
    }

    .searchbox .ais-SearchBox-form::before {
        font-size: 15px;
    }
}
@media (max-width: 575.98px) {
    .search-pagination {
        display: none;
    }
    .search-pagination-responsive {
        display: block;
    }
}
@media (max-width: 399.98px) {
    .search-panel .ais-Hits-list {
        grid-template-columns: 100%;
    }
}
</style>